import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../_common/application/ts/Glob';
import { NullHandling } from '../../../_common/platform/ts/nullHandling';
import { GaugeStore, IGaugeState } from './stores/GaugeStore';

import * as Config from './config';
import * as Utils from '../../../_common/application/ts/Utilities';
import * as AttrQueryValuesFormat from '../../../_common/platform/ts/AttrQueryValuesFormat';
import {
    WidgetStore,
    IGaugeWidgetState,
    IGaugeWidgetParameters
} from '../../../pdc-widget-gauge/src/ts/stores/WidgetStore';

import { DEFAULT_WIDGET_HEIGHT, DEFAULT_WIDGET_WIDTH } from '../../../pdc-platform/src/tsx/Widget';

import { BarGauge, Geometry as BarGeometry, Margin, Label as BarLabel } from 'devextreme-react/bar-gauge';

import {
    CircularGauge,
    Scale as CircularScale,
    Label,
    RangeContainer as CircularRangeContainer,
    Range as CircularRange,
    Tooltip,
    Title,
    Text,
    Font,
    Tick,
    MinorTick,
    Format,
    ValueIndicator as CircularValueIndicator,
    SubvalueIndicator as CircularSubValueIndicator,
    Geometry as CircularGeometry
} from 'devextreme-react/circular-gauge';

import {
    LinearGauge,
    Scale as LinearScale,
    RangeContainer as LinearRangeContainer,
    Range as LinearRange,
    ValueIndicator as LinearValueIndicator,
    SubvalueIndicator as LinearSubValueIndicator,
    Geometry as LinearGeometry
} from 'devextreme-react/linear-gauge';

import { themeVars } from '../../../pdc-platform/src/ts/themes/themeConstants';
import { IValuesCollection } from '../../../_common/platform/ts/appTheme';
import { ISize } from '../../../_common/platform/ts/Interfaces';
import { IWidgetStoreStateOptions } from '../../../_common/platform/ts/BaseWidgetStore';

declare var Color: any;

function getColorAndOpacity(useRangeColors, colorBox) {
    let fontColor;
    let fontColor_opacity;

    if (!useRangeColors) {
        fontColor = colorBox;
        fontColor_opacity = Color(fontColor).alpha();
    }
    return { color: fontColor, opacity: fontColor_opacity };
}

function getThemeFont(fontParameterString: string, theme: IValuesCollection) {
    let fontLabel = theme[fontParameterString];
    if (fontLabel == null) {
        fontLabel = {
            face: theme['#font-main'],
            size: theme['font-main-size'],
            weight: theme['font-main-weight'],
            color: Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.4).hexString()
        };
    }

    return fontLabel;
}

interface IState {
    storeState: IGaugeWidgetState;
    gaugeState: IGaugeState;

    scaleLimits: {
        endValue: number;
        startValue: number;
    };

    gaugeData: any[];
}

export class Module extends React.Component<
    {
        store: WidgetStore;
        gaugeStore: GaugeStore;
        options?;
        glob: IGlob;
    },
    IState
> {
    private barGaugeInstance = null;
    private circularGaugeInstance = null;
    private linearGaugeInstance = null;

    getState() {
        const storeState = $.extend(true, {}, this.props.store.getState());
        const gaugeState = $.extend(true, {}, this.props.gaugeStore.getState());

        return { storeState: storeState, gaugeState: gaugeState };
    }

    constructor(props) {
        super(props);

        this.state = _.extend({}, this.getState(), {
            scaleLimits: {
                startValue: 0,
                endValue: 100
            },
            gaugeData: []
        });
        Utils.devExpressAddCustomPalette(); //LL: 14.11.23: from WillMount
    }

    getAttributeLabel = (attribute) => {
        // agregate:"count"
        // attrib:Array[1]
        // attribType:"e"
        // dataSourceID:14
        // distinct:undefined
        // filter:Array[0]
        // label:"Products"
        // value:77

        if (attribute == null) {
            return '';
        }

        let label = attribute.label;

        if (typeof label == 'undefined' || label === '') {
            label = '';

            if (attribute != null && attribute.attribute) {
                label = this.props.glob.AttrQueryStore.getReferredAttributeLabel(
                    attribute.attribute.join('.'),
                    attribute.dataSourceID
                );
            }
        }

        return label;
    };

    getCurrentCurrency = (savedValue: string, theme: IValuesCollection) => {
        if (savedValue != null) {
            return savedValue;
        }

        return theme[themeVars.currencySelector];
    };

    getTitle(title: string, theme: IValuesCollection) {
        if (theme['gauge-title-visible'] === true && theme['widget-always-title-visible']) {
            const fontTitle = getThemeFont('gauge-title-font', theme);

            return (
                <Title text={title} horizontalAlignment="center" verticalAlignment="top">
                    <Font
                        size={fontTitle.size}
                        color={fontTitle.color}
                        opacity={Color(fontTitle.color).alpha()}
                        family={fontTitle.face}
                        weight={fontTitle.weight}
                    />
                </Title>
            );
        } else {
            return null;
        }
    }

    getLabelFormat(FormatChooserResult: any) {
        const labelFormat = FormatChooserResult.formatFront || 'decimal';
        const precision = FormatChooserResult.precision != null ? parseInt(FormatChooserResult.precision) : 0;

        let props = { type: labelFormat, precision: precision };

        if (labelFormat === 'default') {
            props.type = 'decimal';
        } else if (labelFormat.indexOf('currency') >= 0) {
            props['currency'] = FormatChooserResult.currency;
        }

        return <Format {...props} />;
    }

    getCircularScale(theme: IValuesCollection) {
        const retData = this.getScaleValue();
        const fontScaleLabel = getThemeFont('gauge-font-scale-label', theme);
        const fontColor2 = getColorAndOpacity(theme['gauge-scale-label-use-range-color'], fontScaleLabel.color);

        return (
            <CircularScale endValue={retData.scale.endValue} startValue={retData.scale.startValue}>
                <Tick
                    visible={theme['gauge-line-tick-visible']}
                    color={theme['gauge-line-tick-color']}
                    length={theme['gauge-line-tick-length']}
                    width={theme['gauge-line-tick-width']}
                />
                <MinorTick
                    visible={theme['gauge-line-tick-minor-visible']}
                    color={theme['gauge-line-tick-minor-color']}
                    length={theme['gauge-line-tick-minor-length']}
                    width={theme['gauge-line-tick-minor-width']}
                />
                <Label
                    visible={theme['gauge-scale_label-visible']}
                    useRangeColors={theme['gauge-scale-label-use-range-color']}
                    customizeText={(label) => {
                        return this.customizeText(label, theme, 'gauge-scale_label-format', this.state.scaleLimits);
                    }}
                >
                    {this.getLabelFormat(theme['gauge-scale_label-format'])}
                    <Font
                        size={fontScaleLabel.size}
                        color={fontColor2.color}
                        opacity={fontColor2.opacity}
                        family={fontScaleLabel.face}
                        weight={fontScaleLabel.weight}
                    />
                </Label>
            </CircularScale>
        );
    }

    getLinearScale(theme: IValuesCollection) {
        const retData = this.getScaleValue();
        const fontScaleLabel = getThemeFont('gauge-font-scale-label', theme);
        const fontColor2 = getColorAndOpacity(theme['gauge-scale-label-use-range-color'], fontScaleLabel.color);

        return (
            <LinearScale endValue={retData.scale.endValue} startValue={retData.scale.startValue}>
                <Tick
                    visible={theme['gauge-line-tick-visible']}
                    color={theme['gauge-line-tick-color']}
                    length={theme['gauge-line-tick-length']}
                    width={theme['gauge-line-tick-width']}
                />
                <MinorTick
                    visible={theme['gauge-line-tick-minor-visible']}
                    color={theme['gauge-line-tick-minor-color']}
                    length={theme['gauge-line-tick-minor-length']}
                    width={theme['gauge-line-tick-minor-width']}
                />
                <Label
                    visible={theme['gauge-scale_label-visible']}
                    useRangeColors={theme['gauge-scale-label-use-range-color']}
                    customizeText={(label) => {
                        return this.customizeText(label, theme, 'gauge-scale_label-format', this.state.scaleLimits);
                    }}
                >
                    {this.getLabelFormat(theme['gauge-scale_label-format'])}
                    <Font
                        size={fontScaleLabel.size}
                        color={fontColor2.color}
                        opacity={fontColor2.opacity}
                        family={fontScaleLabel.face}
                        weight={fontScaleLabel.weight}
                    />
                </Label>
            </LinearScale>
        );
    }

    getCircularRanges(theme) {
        let ranges = [];

        ranges = theme['gauge-ranges'].slice(0);
        if (
            theme['gauge-ranges'] != null &&
            this.state.scaleLimits.endValue != 0 &&
            theme['range-color-as-percentage']
        ) {
            ranges = [];

            let max1 = this.state.scaleLimits.endValue;

            _.each(theme['gauge-ranges'], (item: any, index) => {
                ranges.push(
                    <CircularRange
                        key={index}
                        startValue={(item.startValue * max1) / 100}
                        endValue={Math.ceil((item.endValue * max1) / 100.0)}
                        color={item.color}
                    />
                );
            });
        }

        return ranges;
    }

    getLinearRanges(theme) {
        let ranges = [];

        ranges = theme['gauge-ranges'].slice(0);

        if (
            theme['gauge-ranges'] != null &&
            this.state.scaleLimits.endValue != 0 &&
            theme['range-color-as-percentage']
        ) {
            ranges = [];

            let max1 = this.state.scaleLimits.endValue;

            _.each(theme['gauge-ranges'], (item: any, ind) => {
                ranges.push(
                    <LinearRange
                        key={ind}
                        startValue={(item.startValue * max1) / 100}
                        endValue={Math.ceil((item.endValue * max1) / 100.0)}
                        color={item.color}
                    />
                );
            });
        }

        return ranges;
    }

    getBarGaugeLabel(theme: IValuesCollection) {
        const nullHandler = new NullHandling(theme);
        const bar_formatChooserField = theme['widget-gauge-bar_valuesFormat'];
        const fontBarLabel = getThemeFont('gauge-bar-values-font', theme);
        const fontColor1 = getColorAndOpacity(theme['widget-gauge-bar-scaleLabel_UseRangeColors'], fontBarLabel.color);

        return (
            <BarLabel
                visible={theme['widget-gauge-bar_labelVisible']}
                indent={theme['widget-gauge-bar_labelIndent']}
                connectorWidth={theme['widget-gauge-bar_labelConnectorWidth']}
                customizeText={(barValue) => {
                    let _barValue: any = barValue;
                    let _value = barValue.value;
                    if (bar_formatChooserField.formatFront === 'percent') {
                        if (this.state.scaleLimits.endValue !== 0) {
                            _value = _value / this.state.scaleLimits.endValue;
                        }
                    }

                    let labelText = _value.toString();

                    let newData = [];
                    if (typeof _barValue.index !== 'undefined') {
                        let data = this.state.gaugeData;

                        for (let i = 0; i < data.length; i++) {
                            if (data[i].subValueType === 'main' || data[i].subValueType === 'sub') {
                                newData.push(data[i]);
                            }
                        }

                        let valueText = AttrQueryValuesFormat.formatNumeric(
                            _value,
                            {
                                formatFront: bar_formatChooserField.formatFront,
                                precision: bar_formatChooserField.precision,
                                useDigitGrouping: bar_formatChooserField.useDigitGrouping,
                                customFormat: bar_formatChooserField.customFormat,
                                currency: this.getCurrentCurrency(bar_formatChooserField.currency, theme)
                            },
                            nullHandler
                        );

                        labelText = this.getAttributeLabel(newData[_barValue.index]) + '<br>' + valueText;
                    } else {
                        labelText = AttrQueryValuesFormat.formatNumeric(
                            _value,
                            {
                                formatFront: bar_formatChooserField.formatFront,
                                precision: bar_formatChooserField.precision,
                                useDigitGrouping: bar_formatChooserField.useDigitGrouping,
                                customFormat: bar_formatChooserField.customFormat,
                                currency: this.getCurrentCurrency(bar_formatChooserField.currency, theme)
                            },
                            nullHandler
                        );
                    }

                    return labelText;
                }}
            >
                {this.getLabelFormat(theme['widget-gauge-bar_valuesFormat'])}
                <Font
                    size={fontBarLabel.size}
                    color={fontColor1.color}
                    opacity={fontColor1.opacity}
                    family={fontBarLabel.face}
                    weight={fontBarLabel.weight}
                />
            </BarLabel>
        );
    }

    handleOnStoreChange = () => {
        this.setState(this.getState());
    };

    handleOnDataChanged = () => {
        const runTimeWidgetID = this.props.store.getRunTimeWidgetID();
        const gaugeState = this.props.gaugeStore.getState();

        if (runTimeWidgetID !== gaugeState.options.runTimeWidgetID) {
            return;
        }

        let sl = gaugeState.scaleLimits;
        const scaleLimits = this.state.scaleLimits;

        if (!_.isEmpty(sl) && (scaleLimits.endValue !== sl.endValue || scaleLimits.startValue !== sl.startValue)) {
            //VR
            this.setState({
                scaleLimits: {
                    endValue: sl.endValue,
                    startValue: sl.startValue
                }
            });
        }

        this.setState({
            gaugeData: gaugeState.data
        });
    };

    /// return 2 variants: 1) poor values 2) percentage:
    getScaleValue = () => {
        //let storeState = this.props.gaugeStore.getState();
        let self = this;

        let retPoorValues = { value: null, subvalues: [] };
        let values = [];

        if (this.state.gaugeData != null && this.state.gaugeData.length > 0) {
            // retPoorValues.value = storeState.data[0].value;  //mainValuePoor;
            // values.push(storeState.data[0].value);

            for (let i = 0; i < this.state.gaugeData.length; i++) {
                if (this.state.gaugeData[i].subValueType === 'main' && retPoorValues.value == null) {
                    retPoorValues.value = this.state.gaugeData[i].value;
                } else if (this.state.gaugeData[i].subValueType !== 'hide') {
                    retPoorValues.subvalues.push(this.state.gaugeData[i].value);
                }

                if (this.state.gaugeData[i].subValueType != 'hide') {
                    values.push(this.state.gaugeData[i].value);
                }
            }
        }

        return {
            scale: {
                endValue: self.state.scaleLimits.endValue,
                startValue: self.state.scaleLimits.startValue
            },
            retPoorValues: retPoorValues,
            startValue: this.state.scaleLimits.startValue,
            endValue: self.state.scaleLimits.endValue,
            values: values
        };
    };

    componentDidMount() {
        const container = this.state.storeState.options.container;

        this.props.store.addChangeListener(this.handleOnStoreChange);
        this.props.gaugeStore.addChangeListener(this.handleOnDataChanged);

        $(container).on('resize', () => {
            let instance = this.getGaugeInstance();

            if (instance != null) {
                instance.render(); //LL: 14.11.23: this is important <============
            }
        });

        this.props.store.setCultureValues().done(() => {
            this.updateData();
        });
    }

    componentWillUnmount() {
        this.props.store.removeChangeListener(this.handleOnStoreChange);
        this.props.gaugeStore.removeChangeListener(this.handleOnDataChanged);
    }

    componentDidUpdate(prevProps, prevState: IState) {
        const widgetParameters = this.props.store.getWidgetParameters();

        if (!widgetParameters) {
            return;
        }

        const prevParams = prevState.storeState.data.values[Config.moduleName];

        this.props.store.setCultureValues().done(() => {
            if (!compareObjects(prevParams, widgetParameters)) {
                this.updateData(); //strong update because input changed!
            } else if (this.state.storeState.globalStateChanged !== prevState.storeState.globalStateChanged) {
                this.updateData(); //strong update because filters changed
            } else if (this.state.storeState.refreshChanged !== prevState.storeState.refreshChanged) {
                this.refreshWidget(); //update depends of frontend Age or manual refresh
            }
        });
    }

    refreshWidget() {
        const aqlParameters = this.props.store.getAQLParameters();
        const gaugeStoreState = this.props.gaugeStore.getState() as any;

        if (WidgetStore.widgetNeedsRefresh(aqlParameters, gaugeStoreState)) {
            this.updateData();
        }
    }

    saveInstance_Bar = (e) => {
        this.barGaugeInstance = e.component;
        // this.props.store.setInstance(chartInstance);
        // this.setState({chartComponentReact: chartInstance});
    };

    destroyInstance_Bar = (e) => {
        //let comp = e.component;
        this.barGaugeInstance = null;
        //LL: see Chart:
        // this.props.store.setInstance(null);
        // this.setState({chartComponentReact: null});
    };

    saveInstance_Circular = (e) => {
        this.circularGaugeInstance = e.component;
    };

    destroyInstance_Circular = (e) => {
        this.circularGaugeInstance = null;
    };

    saveInstance_Linear = (e) => {
        this.linearGaugeInstance = e.component;
    };

    destroyInstance_Linear = (e) => {
        this.linearGaugeInstance = null;
    };

    getGaugeInstance() {
        const widgetParameters = this.props.store.getWidgetParameters<IGaugeWidgetParameters>();

        if (!widgetParameters) {
            return null;
        }

        switch (widgetParameters.gaugeType) {
            case 'circularGauge':
                return this.circularGaugeInstance;
            case 'linearGauge':
                return this.linearGaugeInstance;
            case 'barGauge':
                return this.barGaugeInstance;
        }

        return null;
    }

    isInsideCKE() {
        const container = this.state.storeState.options.container;

        let isInside = false;

        if (container != null) {
            let cke: any = $(container).closest('.cke-pdc-widget');

            if (cke != null && cke.length > 0) {
                isInside = true;
            }
        }
        return isInside;
    }

    getContainerSize(): ISize<number> {
        let height = 0;
        let width = 0;

        const container = this.state.storeState.options.container;

        //import { DEFAULT_WIDGET_HEIGHT, DEFAULT_WIDGET_WIDTH } from '../../../pdc-platform/src/tsx/Widget';
        if (container != null) {
            height = $(container).height();
            width = $(container).width();

            let cke: any = $(container).parents('.cke-pdc-widget');

            if (cke != null && cke.length > 0) {
                let hasInline = cke.hasClass('inline-mode');
                let hasAutoSize = cke.hasClass('auto-size');
                let hasWidthSet = cke.hasClass('width-set');
                let hasHeightSet = cke.hasClass('height-set');
                //let hasWhMode = cke.hasClass('wh-mode');
                let ckeH = cke.css('height'); //LL: unlike Chart: not "0px" if not set, but "3.3333px"

                // if (height === 0 && ckeH === '0px') {
                //     //LL: for Chart, bad here
                //     //H = DEFAULT_WIDGET_HEIGHT; // 400
                //     //cke.css("height", (H+10) + "px");
                // }

                if (height === 0 && hasAutoSize && !hasHeightSet) {
                    height = DEFAULT_WIDGET_HEIGHT; //400;
                    //cke.css("height", H + "px");
                }

                if (hasInline && !hasHeightSet) {
                    height = DEFAULT_WIDGET_HEIGHT; //400;
                    cke.css('height', height + 'px');
                }

                if (height === 0 && hasAutoSize && hasHeightSet && ckeH !== '0px') {
                    height = cke[0].clientHeight;
                }

                if (width === 0 && hasAutoSize && !hasWidthSet) {
                    width = DEFAULT_WIDGET_WIDTH; //400;
                    //cke.css("width", W + "px");
                }

                if (width === 0 && hasInline && !hasWidthSet) {
                    width = DEFAULT_WIDGET_WIDTH; //400;
                    //cke.css("width", W + "px");
                }

                if (width === 0 && hasInline && hasWidthSet) {
                    width = cke[0].clientWidth;
                }

                if (width === 0 && hasAutoSize && hasWidthSet) {
                    width = cke[0].clientWidth;
                }
            }
        }

        return { height, width };
    }

    getContent(options: IWidgetStoreStateOptions) {
        const widgetParameters = this.props.store.getWidgetParameters<IGaugeWidgetParameters>();

        if (!widgetParameters) {
            return;
        }

        const { layoutData } = options;

        let height: string = '100%';
        let width: string = '100%';

        if (options.inlineMode && layoutData?.parentHeight != null) {
            height = layoutData.parentHeight + 'px';
        } else {
            const isInCKE = this.isInsideCKE();

            if (isInCKE) {
                //LL: 14.12.23: unlike Charts, Gauge has no default size
                const containerSize = this.getContainerSize();

                height = containerSize.height + 'px';
                width = containerSize.width + 'px';
            }
        }

        const retData = this.getScaleValue();
        const theme = this.props.store.getTheme();
        const Title = this.getTitle(widgetParameters.name, theme);
        const Tooltip = this.getTooltip(theme);

        switch (widgetParameters.gaugeType) {
            case 'circularGauge':
                const ValueIndicator = this.getCircularValueIndicator(theme);
                const SubValueIndicator = this.getCircularSubValueIndicator(theme);
                const Scale = this.getCircularScale(theme);
                const Ranges = this.getCircularRanges(theme);

                //LL: 14.11.23: onDisposing, onInitialized, gaugeStyle
                return (
                    <CircularGauge
                        value={retData.retPoorValues.value}
                        subvalues={retData.retPoorValues.subvalues}
                        style={{ width: width, height: height }}
                        onInitialized={this.saveInstance_Circular}
                        onDisposing={this.destroyInstance_Circular}
                    >
                        {Title}
                        {Tooltip}
                        <CircularGeometry
                            startAngle={theme['gauge-circle-start-angle']}
                            endAngle={theme['gauge-circle-end-angle']}
                        />
                        <CircularRangeContainer
                            offset={theme['gauge-circle-scale-offset']}
                            width={theme['gauge-circle-scale-width']}
                            backgroundColor={theme['gauge-circle-scale-color']}
                        >
                            {Ranges}
                        </CircularRangeContainer>

                        {ValueIndicator}
                        {SubValueIndicator}
                        {Scale}
                    </CircularGauge>
                );
            case 'linearGauge':
                const linearValueIndicator = this.getLinearValueIndicator(theme);
                const linearSubValueIndicator = this.getLinearSubValueIndicator(theme);
                const linearScale = this.getLinearScale(theme);
                const linearRanges = this.getLinearRanges(theme);

                //LL: 14.11.23: onDisposing, onInitialized, gaugeStyle
                return (
                    <LinearGauge
                        value={retData.retPoorValues.value}
                        subvalues={retData.retPoorValues.subvalues}
                        style={{ width: width, height: height }}
                        onInitialized={this.saveInstance_Linear}
                        onDisposing={this.destroyInstance_Linear}
                    >
                        {Title}
                        {Tooltip}
                        <LinearGeometry orientation={theme['gauge-line-geometry-orientation']} />
                        <LinearRangeContainer
                            offset={theme['gauge-line-scale-offset']}
                            width={theme['gauge-line-scale-width']}
                            backgroundColor={theme['gauge-line-scale-color']}
                        >
                            {linearRanges}
                        </LinearRangeContainer>

                        {linearValueIndicator}
                        {linearSubValueIndicator}
                        {linearScale}
                    </LinearGauge>
                );
            case 'barGauge':
                let labelOverlapped: 'hide' | 'none' = 'hide';

                if (theme['widget-gauge-bar_labelOverlapping'] === false) {
                    labelOverlapped = 'none';
                }

                let myPalette = theme['widget-gauge-palette-color'];
                let paletteDefault: any = 'Material';

                if (myPalette != null && myPalette.defaultPaletteName != null) {
                    if (myPalette.defaultPaletteName !== 'Custom (enter below)') {
                        paletteDefault = myPalette.defaultPaletteName;
                    } else {
                        paletteDefault = myPalette.customPaletteArray;

                        if (!Array.isArray(paletteDefault) || paletteDefault.length === 0) {
                            paletteDefault = ['#333399'];
                        }
                    }
                }

                const barLabel = this.getBarGaugeLabel(theme);

                //LL: 14.11.23: onDisposing, onInitialized, gaugeStyle
                return (
                    <BarGauge
                        style={{ width: width, height: height }}
                        onInitialized={this.saveInstance_Bar}
                        onDisposing={this.destroyInstance_Bar}
                        endValue={retData.endValue}
                        startValue={retData.startValue}
                        values={retData.values}
                        palette={paletteDefault}
                        baseValue={theme['widget-gauge-bar_baseValue']}
                        backgroundColor={theme['widget-gauge-bar-background-color']}
                        barSpacing={theme['widget-gauge-bar_spacing']}
                        relativeInnerRadius={theme['widget-gauge-bar_relativeInnerRadius']}
                        resolveLabelOverlapping={labelOverlapped}
                    >
                        {Title}
                        {Tooltip}
                        <BarGeometry
                            startAngle={theme['widget-gauge-bar_geometry-start-angle']}
                            endAngle={theme['widget-gauge-bar_geometry-end-angle']}
                        />
                        <Margin
                            bottom={theme['widget-gauge-bar_marginBottom']}
                            left={theme['widget-gauge-bar_marginLeft']}
                            right={theme['widget-gauge-bar_marginRight']}
                            top={theme['widget-gauge-bar_marginTop']}
                        />
                        {barLabel}
                    </BarGauge>
                );
        }
    }

    updateData() {
        const widgetParameters = this.props.store.getWidgetParameters<IGaugeWidgetParameters>();

        if (widgetParameters == null) {
            return;
        }

        const theme = this.props.store.getTheme();
        const runTimeWidgetID = this.props.store.getRunTimeWidgetID();

        if (!this.props.store.allowApplyData(theme)) {
            //Issue 73957: Showing this message within a widget produces isses in inline mode.
            this.props.glob.AppActions.showNotification_Warning('Click Apply button to show values');
            return;
        }

        const cultureValues = this.props.store.getCultureValues();
        const aqlParameters = this.props.store.getAQLParameters(cultureValues);

        this.props.gaugeStore.actions.gaugeGetData(
            widgetParameters,
            runTimeWidgetID,
            aqlParameters,
            theme,
            cultureValues
        );
    }

    getCircularValueIndicator(myTheme: IValuesCollection) {
        let props = {
            width: myTheme['gauge-circle-main-indicator-width'],
            type: myTheme['gauge-circle-main-indicator-type'],
            color: myTheme['gauge-circle-main-indicator-color'],
            offset: myTheme['gauge-circle-main-indicator-offset']
        };

        return (
            <CircularValueIndicator {...props} size={myTheme['gauge-line-main-indicator-size']}>
                <Text
                    customizeText={(obj) =>
                        this.customizeText(obj, myTheme, 'gauge-line_valuesFormat', this.state.scaleLimits)
                    }
                >
                    <Font
                        size={myTheme['gauge-line-main-indicator-font-size']}
                        color={myTheme['gauge-line-main-indicator-font-color']}
                        opacity={1}
                    />
                    {this.getLabelFormat(myTheme['gauge-line_valuesFormat'])}
                </Text>
            </CircularValueIndicator>
        );
    }

    getLinearValueIndicator(myTheme: IValuesCollection) {
        let props = {
            width: 16,
            type: myTheme['gauge-line-main-indicator-type'],
            backgroundColor: myTheme['gauge-line-main-indicator-backcolor'],
            color: myTheme['gauge-line-main-indicator-color'],
            offset: myTheme['gauge-line-main-indicator-offset']
        };

        return (
            <LinearValueIndicator {...props} size={myTheme['gauge-line-main-indicator-size']}>
                <Text
                    customizeText={(obj) =>
                        this.customizeText(obj, myTheme, 'gauge-line_valuesFormat', this.state.scaleLimits)
                    }
                >
                    <Font
                        size={myTheme['gauge-line-main-indicator-font-size']}
                        color={myTheme['gauge-line-main-indicator-font-color']}
                        opacity={1}
                    />
                    {this.getLabelFormat(myTheme['gauge-line_valuesFormat'])}
                </Text>
            </LinearValueIndicator>
        );
    }

    getCircularSubValueIndicator(theme: IValuesCollection) {
        const props = {
            type: theme['gauge-circle-sub-indicator-type'],
            color: theme['gauge-circle-sub-indicator-color'],
            offset: theme['gauge-circle-sub-indicator-offset'],
            width: theme['gauge-circle-sub-indicator-width']
        };

        return (
            <CircularSubValueIndicator {...props}>
                <Text
                    customizeText={(obj) =>
                        this.customizeText(obj, theme, 'gauge-circle-sub-valuesFormat', this.state.scaleLimits)
                    }
                >
                    <Font
                        size={theme['gauge-circle-sub-indicator-font-size']}
                        color={theme['gauge-circle-sub-indicator-font-color']}
                        opacity={1}
                        family={theme['#font-main']}
                    />
                    {this.getLabelFormat(theme['gauge-circle-sub-valuesFormat'])}
                </Text>
            </CircularSubValueIndicator>
        );
    }

    getLinearSubValueIndicator(theme: IValuesCollection) {
        const props = {
            type: theme['gauge-line-sub-indicator-type'],
            color: theme['gauge-line-sub-indicator-color'],
            offset: theme['gauge-line-sub-indicator-offset'],
            length: theme['gauge-line-sub-indicator-length']
        };

        return (
            <LinearSubValueIndicator {...props}>
                <Text
                    customizeText={(obj) =>
                        this.customizeText(obj, theme, 'gauge-line_sub-valuesFormat', this.state.scaleLimits)
                    }
                >
                    <Font
                        size={theme['gauge-line-sub-indicator-font-size']}
                        color={theme['gauge-line-sub-indicator-font-color']}
                        opacity={1}
                        family={theme['#font-main']}
                    />
                    {this.getLabelFormat(theme['gauge-line_sub-valuesFormat'])}
                </Text>
            </LinearSubValueIndicator>
        );
    }

    customizeText = (obj, theme: IValuesCollection, themeFormatter, scaleLimits) => {
        let _value = obj.value;
        const formatChooser = theme[themeFormatter];
        const nullHandler = new NullHandling(theme);

        if (formatChooser.formatFront === 'percent') {
            if (scaleLimits.endValue !== 0) {
                _value = scaleLimits.endValue;
            }
        }

        return AttrQueryValuesFormat.formatNumeric(
            _value,
            {
                formatFront: formatChooser.formatFront,
                precision: formatChooser.precision,
                useDigitGrouping: formatChooser.useDigitGrouping,
                formatZeroAsBlank: formatChooser.formatZeroAsBlank,
                useFiscalPrefix: formatChooser.useFiscalPrefix,
                fiscalYearDivider: formatChooser.fiscalYearDivider,
                customFormat: formatChooser.customFormat,
                currency: this.getCurrentCurrency(formatChooser.currency, theme)
            },
            nullHandler
        );
    };

    getTooltip(theme: IValuesCollection) {
        const nullHandler = new NullHandling(theme);
        const fontTooltip = getThemeFont('gauge-font-tooltip', theme);
        const self = this;

        return (
            <Tooltip
                enabled={theme['widget-gauge-tooltipVisible']}
                color={theme['widget-gauge-tooltipBackColor']}
                opacity={Color(theme['widget-gauge-tooltipBackColor']).alpha()}
                customizeTooltip={(obj) => {
                    let _obj: any = obj;
                    let _value = obj.value;
                    const tooltip_formatChooserField = theme['widget-gauge-tooltipFormat'];
                    const data = this.state.gaugeData;

                    if (tooltip_formatChooserField.formatFront === 'percent') {
                        if (self.state.scaleLimits.endValue !== 0) {
                            _value = _value / self.state.scaleLimits.endValue; // * 100.0
                        }
                    }

                    let txt = AttrQueryValuesFormat.formatNumeric(
                        _value,
                        {
                            formatFront: tooltip_formatChooserField.formatFront,
                            precision: tooltip_formatChooserField.precision,
                            useDigitGrouping: tooltip_formatChooserField.useDigitGrouping,
                            formatZeroAsBlank: tooltip_formatChooserField.formatZeroAsBlank,
                            customFormat: tooltip_formatChooserField.customFormat,
                            currency: self.getCurrentCurrency(tooltip_formatChooserField.currency, theme)
                        },
                        nullHandler
                    );

                    let index = 0,
                        attrType = 'undef'; //sub, main
                    if (_obj.type === 'subvalue-indicator') {
                        attrType = 'sub';
                    } else if (_obj.type === 'value-indicator') {
                        attrType = 'main';
                        // } else if (typeof this.index !== 'undefined') {
                        //     attrType = 'hide';
                    }

                    let newData = [];

                    for (let i = 0; i < data.length; i++) {
                        if (attrType === 'main' && data[i].subValueType === attrType) {
                            newData.push(data[i]);
                            index = 0;
                            break;
                        } else if (attrType === 'sub' && data[i].subValueType === attrType) {
                            newData.push(data[i]);
                            index = _obj.index;
                        } else if (attrType === 'undef' && data[i].subValueType !== 'hide') {
                            // for BAR only. Here no TYPE, so get all not hidden!
                            newData.push(data[i]);
                            index = _obj.index;
                        }
                    }

                    return {
                        text: self.getAttributeLabel(newData[index]) + ' ' + txt
                    };
                }}
            >
                <Font
                    size={fontTooltip.size}
                    color={fontTooltip.color}
                    opacity={Color(fontTooltip.color).alpha()}
                    family={fontTooltip.face}
                    weight={fontTooltip.weight}
                />
                {this.getLabelFormat(theme['widget-gauge-tooltipFormat'])}
            </Tooltip>
        );
    }

    render() {
        const options = this.props.store.getOptions();
        const { runTimeWidgetID } = options;
        const childID = 'gauge_Container_' + runTimeWidgetID + '_inner';

        return (
            <div
                className="pdc-widget-gauge"
                style={{
                    position: options.inlineMode ? 'relative' : 'absolute'
                }}
            >
                <div
                    id={childID}
                    style={{
                        height: '100%',
                        margin: '0 auto',
                        //float: 'left', //LL: 14.11.23: rem.  Why was it ?
                        width: '100%'
                    }}
                >
                    {this.getContent(options)}
                </div>
            </div>
        );
    }
}
